import type { IJobTaskTemplate } from '@/interfaces'
import TaskTemplate from './TaskTemplate'

class JobTaskTemplateUpdate extends TaskTemplate implements IJobTaskTemplate {
  taskTemplateId: string

  isCompleted: boolean

  constructor(jobTaskTemplateUpdate?: any) {
    super(jobTaskTemplateUpdate)

    this.taskTemplateId = jobTaskTemplateUpdate?.taskTemplateId ?? ''
    this.isCompleted = jobTaskTemplateUpdate?.isCompleted ?? false
  }
}

export default JobTaskTemplateUpdate
